import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSurveys = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/survey/get_survey`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetSurveys = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["surveys"],
    queryFn: fetchSurveys,
    enabled,
    refetchOnWindowFocus: false,
  });
};

export default useGetSurveys;
